var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.state.loading)?_c('Loading'):_vm._e(),(!_vm.state.token)?_c('Navbar'):_vm._e(),(
      _vm.state.token &&
      !_vm.$route.path.includes('dashboard') &&
      !_vm.$route.path.includes('advancetrade')
    )?_c('DashNavbar',{staticStyle:{"position":"fixed"}}):_vm._e(),(_vm.showPWA)?_c('div',{staticClass:"pwa-box"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.showPWA = false}}},[_vm._v("×")]),_c('p',[_vm._v("سه سوت سه‌سوت چنج رو نصب کن")]),_c('div',[_c('button',{staticClass:"install",on:{"click":function($event){return _vm.installPWA()}}},[_vm._v("نصب سه‌سوت چنج")])])]):_vm._e(),_c('div',{class:[
      !_vm.state.token
        ? 'mt-73'
        : _vm.state.token &&
          !_vm.$route.path.includes('dashboard') &&
          !_vm.$route.path.includes('advancetrade')
        ? 'mt-56'
        : '' ]},[_c('router-view')],1),(!(_vm.isTWA || _vm.isPWA) && _vm.showFooter)?_c('Footer'):_vm._e(),(_vm.isTWA || _vm.isPWA)?_c('TWAFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }